export default __webpack_public_path__ + "static/media/ayo-ogunseinde-2.f4af8f2c.jpg";